export const MessageStatus = Object.freeze({
    SENT:'SENT',
    DELIVERED:'DELIVERED',
    SEEN:'SEEN'
})